import useStableObjectReference from 'hooks/useStableObjectReference'
import usePrevious from 'hooks/usePrevious'

function useSortWasApplied(currentFilters: App.OfferListFilters): boolean {
  const stableFilters = useStableObjectReference(currentFilters)
  const previousFilters = usePrevious(stableFilters)

  if (!previousFilters) return false

  return previousFilters?.sortBy !== stableFilters.sortBy
}

export default useSortWasApplied
